<div class="form-row">
  <wl-profile-search
    #profileSelectorComponent
    [singleProfileSelect]="false"
    (onProfileSelected)="profileSelected($event)"
    [showMemberColumn]="false"
    [showOrgIndColumn]="false"
    [showCustStatusColumn]="true"
    [alwaysExpandAdvancedSearch]="true"
    [hideFooter]="true"
  ></wl-profile-search>
</div>
